/* K Junction collection page: card colour/size pick + add to cart, photo swipe, page tidy-ups */
(function () {
  'use strict';
  if (window.__kjCollection) return; window.__kjCollection = true;
  var IS_COL = !!document.querySelector('.kjch');
  if (IS_COL) document.body.classList.add('kj-is-collection');

  var HEX = { black: '#1b1b1b', white: '#f4f4f2', 'off white': '#EFEBE0', blue: '#2a5bd7', navy: '#1F2A44', 'navy blue': '#1F2A44', 'persian blue': '#1C39BB', 'royal blue': '#2B4FC9', 'sky blue': '#87CEEB', 'light blue': '#9EC5E8', red: '#C62828', maroon: '#6D1B2B', green: '#2E7D32', 'bottle green': '#0F4D2C', olive: '#6B6B2E', mint: '#A8DCC3', grey: '#8c8c8c', gray: '#8c8c8c', charcoal: '#3A3A3A', brown: '#5A3A2E', khaki: '#BDB07A', beige: '#D8C8A8', fawn: '#C8A97E', camel: '#C19A6B', pink: '#F48FB1', 'baby pink': '#F8C8D8', peach: '#F7B89A', purple: '#7B4BA6', lilac: '#C8A2C8', lavender: '#B9A7D9', yellow: '#F2C230', mustard: '#D4A017', orange: '#EF7A26', rust: '#B7472A', cream: '#F3E9D2', teal: '#1F7A7A', aqua: '#4FC3C8', 'sea green': '#2E8B57', magenta: '#C2185B', fuchsia: '#D6338A', coral: '#F2766B', silver: '#C0C0C0', gold: '#C9A227' };
  var hexOf = function (c) { var k = String(c).toLowerCase().trim(); return HEX[k] || HEX[k.split(/[\s/]+/).pop()] || HEX[k.split(/[\s/]+/)[0]] || null; };
  var rs = function (c) { var r = Math.round(c / 100); return 'Rs ' + r.toLocaleString('en-US'); };
  var shortZ = function (z) { return String(z).replace(/ - /g, '–').replace(/ Years?| years?/g, ' Y').replace(/ Months?| months?/g, ' M'); };

  /* ---------- card state ---------- */
  var AGE_KEY = 'kjAge';
  var urlAge = (function () {
    var p = new URLSearchParams(location.search), out = [];
    p.forEach(function (v, k) { if (/^filter\.v\.option\.(size|age)/i.test(k)) out.push(v); });
    return out.length === 1 ? out[0] : null;
  })();
  var getAge = function () { if (urlAge) return urlAge; try { return sessionStorage.getItem(AGE_KEY); } catch (e) { return null; } };
  var setAge = function (z) { try { sessionStorage.setItem(AGE_KEY, z); } catch (e) {} };

  var data = function (card) {
    if (card._kj) return card._kj;
    var el = card.querySelector('[data-kjc-json]'), d;
    try { d = JSON.parse(el.textContent); } catch (e) { d = { ci: -1, si: -1, v: [] }; }
    var on = function (sel, attr) { var b = card.querySelector(sel); return b ? b.getAttribute(attr) : null; };
    d.c = on('.kjc__sw.is-on', 'data-c');
    d.z = on('.kjc__sz.is-on', 'data-z');
    d.touched = false;
    card._kj = d;
    return d;
  };
  var avail = function (d, c, z) {
    return d.v.some(function (v) { return v.a && (d.ci < 0 || c == null || v.o[d.ci] === c) && (d.si < 0 || z == null || v.o[d.si] === z); });
  };
  var pickVariant = function (d) {
    return d.v.filter(function (v) { return v.a && (d.ci < 0 || v.o[d.ci] === d.c) && (d.si < 0 || v.o[d.si] === d.z); })[0];
  };

  var paint = function (card) {
    var d = data(card);
    card.querySelectorAll('.kjc__sw').forEach(function (b) { b.classList.toggle('is-on', b.getAttribute('data-c') === d.c); });
    card.querySelectorAll('.kjc__sz').forEach(function (b) {
      var z = b.getAttribute('data-z'), out = !avail(d, d.c, z);
      b.classList.toggle('is-out', out); b.setAttribute('aria-disabled', out ? 'true' : 'false');
      b.classList.toggle('is-on', !out && z === d.z);
    });
    var lc = card.querySelector('[data-lab="c"]'), lz = card.querySelector('[data-lab="z"]');
    if (lc) lc.textContent = d.c ? 'Colour: ' + d.c : 'Choose a colour';
    if (lz) lz.textContent = d.z ? 'Size: ' + shortZ(d.z) : 'Choose size';
    // price for the chosen option (or the cheapest available match)
    var pool = d.v.filter(function (v) { return v.a && (d.ci < 0 || !d.c || v.o[d.ci] === d.c) && (d.si < 0 || !d.z || v.o[d.si] === d.z); });
    if (pool.length) {
      var best = pool.reduce(function (a, b) { return b.p < a.p ? b : a; });
      var pr = card.querySelector('[data-kjc-price]'), was = card.querySelector('[data-kjc-was]'), bd = card.querySelector('[data-kjc-badge]');
      if (pr) pr.textContent = rs(best.p);
      if (was) { if (best.c > best.p) { was.textContent = rs(best.c); was.classList.remove('kj-hide'); } else was.classList.add('kj-hide'); }
      if (bd) { if (best.c > best.p) { bd.textContent = '-' + Math.floor((best.c - best.p) * 100 / best.c) + '%'; bd.classList.remove('kj-hide'); } else bd.classList.add('kj-hide'); }
    }
    // scarcity for the chosen size
    var low = card.querySelector('[data-kjc-low]'), v = (d.c || d.ci < 0) && (d.z || d.si < 0) ? pickVariant(d) : null;
    if (low && v) { if (v.q > 0 && v.q <= 3) { low.textContent = 'Only ' + v.q + ' left in this size'; low.classList.remove('kj-hide'); } else low.classList.add('kj-hide'); }
  };

  var showImage = function (card, d) {
    if (d.ci < 0 || !d.c) return;
    var v = d.v.filter(function (x) { return x.o[d.ci] === d.c && (x.m || x.img); })[0]; if (!v) return;
    var track = card.querySelector('[data-kjc-track]'); if (!track) return;
    var img = v.m ? track.querySelector('img[data-mid="' + v.m + '"]') : null;
    if (img) { track.scrollTo({ left: img.offsetLeft, behavior: 'smooth' }); return; }
    var first = track.querySelector('img');
    if (first && v.img) { first.removeAttribute('srcset'); first.src = v.img; track.scrollTo({ left: 0 }); }
  };

  var clearErr = function (card) { var e = card.querySelector('[data-kjc-err]'); if (e) e.classList.add('kj-hide'); card.querySelectorAll('.kj-bad').forEach(function (x) { x.classList.remove('kj-bad'); }); };

  /* apply the age the shopper already picked on another card */
  var applyAge = function (card) {
    var z = getAge(); if (!z) return;
    var d = data(card); if (d.touched || d.si < 0 || d.z) return;
    if (card.querySelector('.kjc__sz[data-z="' + (window.CSS && CSS.escape ? CSS.escape(z) : z) + '"]') && avail(d, d.c, z)) { d.z = z; paint(card); }
  };

  var hydrate = function (root) {
    var fresh = (root || document).querySelectorAll('[data-kjc]:not([data-kjc-ready])');
    fresh.forEach(function (card) {
      card.setAttribute('data-kjc-ready', '');
      card.querySelectorAll('.kjc__sw i[data-hex]').forEach(function (i) { var h = hexOf(i.getAttribute('data-hex')); if (h) i.style.background = h; });
      applyAge(card);
      var track = card.querySelector('[data-kjc-track]'), dots = card.querySelectorAll('[data-kjc-dots] i');
      if (track && dots.length) {
        var t;
        track.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(function () { var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth)); dots.forEach(function (d, k) { d.classList.toggle('is-on', k === i); }); }, 60); }, { passive: true });
        if (window.matchMedia('(hover: hover)').matches) {
          card.querySelector('.kjc__media').addEventListener('mouseenter', function () { if (track.scrollLeft < 2 && dots.length > 1) track.scrollTo({ left: track.clientWidth, behavior: 'smooth' }); });
          card.querySelector('.kjc__media').addEventListener('mouseleave', function () { if (!card._kj || !card._kj.c || card._kj.touchedImg !== true) track.scrollTo({ left: 0, behavior: 'smooth' }); });
        }
        // a swipe should not open the product
        var sx = 0, moved = false;
        track.addEventListener('pointerdown', function (e) { sx = e.clientX; moved = false; });
        track.addEventListener('pointermove', function (e) { if (Math.abs(e.clientX - sx) > 8) moved = true; });
        track.addEventListener('click', function (e) { if (moved) { e.preventDefault(); moved = false; } });
      }
    });
    return fresh.length;
  };

  /* size guide for this card's product */
  document.addEventListener('click', function (e) {
    var g = e.target.closest && e.target.closest('[data-kjc-sg]');
    if (!g) return;
    var card = g.closest('[data-kjc]'); if (!card || !window.KJSG) return;
    e.preventDefault();
    var d = data(card); if (!d.sg) return;
    var sizes = Array.prototype.map.call(card.querySelectorAll('.kjc__sz'), function (b) { return b.getAttribute('data-z'); });
    window.KJSG.open(d.sg, {
      sizes: sizes, current: d.z, trigger: g,
      isAvail: function (z) { return avail(d, d.c, z); },
      onPick: function (z) { d.z = z; d.touched = true; setAge(z); clearErr(card); paint(card); resetAdd(card); }
    });
  });

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.kjc__sw, .kjc__sz, [data-kjc-add]');
    if (!b) return;
    var card = b.closest('[data-kjc]'); if (!card) return;
    e.preventDefault();
    var d = data(card);
    if (b.classList.contains('kjc__sw')) {
      var c = b.getAttribute('data-c');
      if (!avail(d, c, null)) return;
      d.c = c; d.touchedImg = true;
      if (d.z && !avail(d, c, d.z)) d.z = null;
      clearErr(card); paint(card); showImage(card, d); resetAdd(card);
    } else if (b.classList.contains('kjc__sz')) {
      var z = b.getAttribute('data-z');
      if (!avail(d, d.c, z)) return;
      d.z = z; d.touched = true; setAge(z);
      clearErr(card); paint(card); resetAdd(card);
      // follow this age on the other cards the shopper hasn't touched
      document.querySelectorAll('[data-kjc]').forEach(function (o) { if (o !== card) applyAge(o); });
    } else {
      add(card, b);
    }
  });

  var resetAdd = function (card) { var a = card.querySelector('[data-kjc-add]'); if (a && a.classList.contains('is-done')) { a.classList.remove('is-done'); a.textContent = '+ ADD TO CART'; } };

  var add = function (card, btn) {
    var d = data(card);
    var needC = d.ci >= 0 && !d.c, needZ = d.si >= 0 && !d.z;
    var err = card.querySelector('[data-kjc-err]');
    if (needC || needZ) {
      err.textContent = needC && needZ ? 'Please choose a colour and size' : needC ? 'Please choose a colour' : 'Please choose a size';
      err.classList.remove('kj-hide');
      ['c', 'z'].forEach(function (k) {
        var blk = card.querySelector('[data-blk="' + k + '"]');
        if (!blk) return;
        blk.classList.remove('kj-bad');
        if ((k === 'c' && needC) || (k === 'z' && needZ)) { void blk.offsetWidth; blk.classList.add('kj-bad'); }
      });
      var first = card.querySelector('.kj-bad');
      if (first && first.getBoundingClientRect().top < 70) first.scrollIntoView({ block: 'center', behavior: 'smooth' });
      return;
    }
    var v = pickVariant(d);
    if (!v) { err.textContent = 'Sorry, this option just sold out'; err.classList.remove('kj-hide'); return; }
    btn.classList.add('is-loading'); btn.textContent = 'ADDING…';
    fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }] }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function (res) {
        btn.classList.remove('is-loading'); btn.classList.add('is-done'); btn.textContent = '✓ ADDED';
        var item = res.items ? res.items[0] : res;
        // inside the side cart: just refresh it (keeps these cards); elsewhere open the side cart
        if (card.closest('[data-kjd]') && window.KJCart) window.KJCart.refresh();
        else document.dispatchEvent(new CustomEvent('kj:added', { detail: { item: item } }));
      })
      .catch(function (er) {
        btn.classList.remove('is-loading'); btn.textContent = '+ ADD TO CART';
        err.textContent = (er && er.description) || 'Could not add. Please try again.'; err.classList.remove('kj-hide');
      });
  };

  /* ---------- 1 / 2 per row on phones ---------- */
  var VIEW_KEY = 'kjColView';
  var setView = function (n) {
    document.body.classList.toggle('kjc-1col', n === '1');
    document.querySelectorAll('[data-kjch-view]').forEach(function (b) { b.classList.toggle('is-on', b.getAttribute('data-kjch-view') === n); b.setAttribute('aria-pressed', b.getAttribute('data-kjch-view') === n ? 'true' : 'false'); });
  };
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-kjch-view]'); if (!b) return;
    var n = b.getAttribute('data-kjch-view'); setView(n);
    try { localStorage.setItem(VIEW_KEY, n); } catch (er) {}
  });
  if (IS_COL) { try { setView(localStorage.getItem(VIEW_KEY) || '2'); } catch (e) { setView('2'); } }

  /* ---------- filters & sort tidy-up ---------- */
  var ageKey = function (t) {
    var s = String(t).toLowerCase(), m = s.match(/(\d+)\s*(?:-|–|to)?\s*(\d+)?\s*(month|m\b|year|y\b)?/);
    if (!m) { var adult = { xs: 1, s: 2, small: 2, m: 3, medium: 3, l: 4, large: 4, xl: 5, 'x large': 5, xxl: 6, '2xl': 6, '3xl': 7 }; var k = s.trim(); return k in adult ? 2000 + adult[k] : 3000; }
    var a = +m[1], unit = m[3] || (s.indexOf('month') >= 0 ? 'month' : s.indexOf('year') >= 0 ? 'year' : '');
    var base = /^m/.test(unit) ? a : /^y/.test(unit) ? a * 12 : 1000 + a;
    return base + (m[2] ? +m[2] / 1000 : 0);
  };
  var sortSizeFacets = function () {
    document.querySelectorAll('#main-collection-filters details, .mobile-facets details').forEach(function (det) {
      var sum = det.querySelector('summary'); if (!sum || !/size|age/i.test(sum.textContent)) return;
      det.querySelectorAll('ul').forEach(function (ul) {
        var lis = Array.prototype.slice.call(ul.children).filter(function (li) { return li.tagName === 'LI' && li.querySelector('input'); });
        if (lis.length < 2) return;
        var sorted = lis.slice().sort(function (x, y) { return ageKey(x.querySelector('input').value) - ageKey(y.querySelector('input').value); });
        if (sorted.every(function (li, i) { return li === lis[i]; })) return;
        sorted.forEach(function (li) { ul.appendChild(li); });
      });
    });
  };
  var tidy = function () {
    document.querySelectorAll('select[name="sort_by"] option[value="relevance"], select[name="sort_by"] option[value="most-relevant"]').forEach(function (o) { if (!o.selected) o.remove(); });
    // the in-stock filter stays on; only its chip is hidden so it isn't mistaken for a choice the shopper made
    var chips = document.querySelectorAll('.active-facets__button');
    var others = 0;
    chips.forEach(function (ch) {
      var t = ch.textContent.toLowerCase();
      if (t.indexOf('availability') >= 0 || t.indexOf('in stock') >= 0) { var li = ch.closest('facet-remove') || ch; li.style.display = 'none'; }
      else others++;
    });
    document.querySelectorAll('.active-facets__button-remove').forEach(function (x) { var w = x.closest('facet-remove') || x; w.style.display = others ? '' : 'none'; });
    sortSizeFacets();
    return hydrate();
  };

  var queued = false;
  var schedule = function () { if (queued) return; queued = true; requestAnimationFrame(function () { queued = false; var n = tidy(); if (n && booted) { try { if (window.theme && theme.wishlist && theme.wishlist.load) theme.wishlist.load(); } catch (e) {} } }); };
  var booted = false;
  new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) { if (muts[i].addedNodes.length) { schedule(); return; } }
  }).observe(document.body, { childList: true, subtree: true });

  /* other scripts (product page, side cart): preselect a size on cards the shopper hasn't touched */
  window.KJCards = {
    hydrate: hydrate,
    follow: function (root, z) {
      if (!z) return;
      hydrate(root);
      Array.prototype.forEach.call((root || document).querySelectorAll('[data-kjc]'), function (card) {
        var d = data(card); if (d.touched || d.si < 0) return;
        var has = Array.prototype.some.call(card.querySelectorAll('.kjc__sz'), function (b) { return b.getAttribute('data-z') === z; });
        if (has && avail(d, d.c, z)) { d.z = z; paint(card); }
      });
    }
  };

  var boot = function () { tidy(); booted = true; };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
